"use strict";
exports.__esModule = true;
exports.TYPOGRAPHY = void 0;
var text_props_1 = require("../text/text.props");
exports.TYPOGRAPHY = {
    huge: text_props_1.TypographyEnum['xxl'],
    large: text_props_1.TypographyEnum['xl'],
    medium: text_props_1.TypographyEnum['lg'],
    small: text_props_1.TypographyEnum['base'],
    tiny: text_props_1.TypographyEnum['sm']
};
//# sourceMappingURL=rating.style.js.map